import React from "react";
import { HiChevronDoubleLeft } from "react-icons/hi";
import { Link } from "react-router-dom";

const Container = ({
  title,
  subtitle,
  link,
  to = "/",
  icon = "",
  children,
  className = "",
}) => {
  return (
    <div className={`container-box ${className || ""}`}>
      {title && (
        <div className="container-box-title">
          <div>
            <div></div>
            <div>
              <h5>{title}</h5>
              <span>{subtitle}</span>
            </div>
          </div>
          {link && (
            <Link to={to}>
              {link}
              <HiChevronDoubleLeft />
            </Link>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Container;
